import { useEffect, useRef } from 'react';
import { logError } from 'packages/lib/utils/logger';
import { sendDataVolumeMetrics } from 'packages/task-man/__test-automation-helpers__/test-automation-helper';
import { loadConfig } from 'packages/lib/config';
import { queueEvent } from 'packages/lib/metrics/helpers';
import { PerformanceResourceTimingFixed } from 'packages/data-mining-qa/utils/performance-metrics';

const env = loadConfig();

export const useServiceLevelMetrics = (): void => {
  const didSendCountMetrics = useRef(false);
  useEffect(() => {
    if (!didSendCountMetrics.current) {
      (() => {
        try {
          const prevSetDate = localStorage.getItem('sent-data-volume-date');
          if (typeof prevSetDate === 'string') {
            const prevDate = new Date(prevSetDate as string);
            const curDate = new Date();
            const hoursDifference =
              Math.abs(curDate.getTime() - prevDate.getTime()) / 36e5;
            if (hoursDifference < 16) return;
          }
          sendDataVolumeMetrics();
          localStorage.setItem(
            'sent-data-volume-date',
            new Date().toDateString()
          );
        } catch (err) {}
        didSendCountMetrics.current = true;
      })();
    }

    const observer = new PerformanceObserver((list) => {
      list.getEntries().forEach((genericEntry) => {
        if (genericEntry.entryType === 'resource') {
          const entry = genericEntry as PerformanceResourceTimingFixed;
          const { name, requestStart, responseStart, responseStatus } = entry;
          if (
            entry.name.startsWith(env.apiHosts.annotationsHost) ||
            entry.name.startsWith(env.apiHosts.annotationsAppApi) ||
            entry.name.startsWith(env.apiHosts.omnitagHost)
          ) {
            void queueEvent({
              event_name: 'sl_metric',
              timestamp: new Date().toISOString(),
              requestUrl: name,
              responseCode: responseStatus,
              responseTime: responseStart - requestStart,
            }).catch(logError);
          }
        }
      });
    });
    observer.observe({ entryTypes: ['resource'] });
    return (): void => observer.disconnect();
  }, []);
};
